module.exports = __webpack_public_path__ + "img/facebook-post.1e777f15.png";